import React, {Component} from 'react';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import Appear from 'components/common/reactAppear';
import {Plan} from './plan';

import {
  Title,
  FooterBlock,
  Content,
  Block,
  Button
} from 'components/landing/components';

import config from 'config/pricing';

import './Pricing.css';


let dumbPricing = dumbBem('l-pricing');
let PricingWrp = tx(dumbPricing)('div');
let Background = tx([{element: 'background'}, dumbPricing])('div');


export class Pricing extends Component {
  render() {
    return (
      <PricingWrp>
        <Background />
        <Block modifier='header'>
          <Content modifier='header'>
            <Title modifier='title'>{config.header.title}</Title>
            <Title modifier='3 description'>{config.header.description}</Title>
            <Button onClick={() => this.props.history.push('/#demo-form')}>REQUEST A DEMO</Button>
          </Content>
          <Content modifier='plans'>
            {
              config.plans.map((plan, id) => <Appear key={id}><Plan
                isMobile={this.props.isMobile}
                {...plan}
              /></Appear>)
            }
          </Content>
        </Block>

        <Block modifier='content'>
          <Content modifier='contact-us'>
            <Title modifier='2 contact-us'>Contact us for more information</Title>
            <Button onClick={() => this.props.history.push('/#demo-form')} modifier='reversed-colors'>REQUEST A DEMO</Button>
          </Content>
        </Block>

        <FooterBlock />
      </PricingWrp>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/pages/pricing/Pricing.js